// extracted by mini-css-extract-plugin
export default {"nameFormContainer":"NewsletterChooseName_nameFormContainer__fwgGc","inputContainer":"NewsletterChooseName_inputContainer__RINxf"};